export default __webpack_public_path__ + "static/1590-06e8ad78e8f5864758bec32d783054b6.gif";